import { createFileRoute } from '@tanstack/react-router'

import { PassesListPage } from '@/features/passes'

export const Route = createFileRoute('/_authenticated/_main/passe/')({
  component: PassesListPage
})
